export default {"src":"/_next/static/media/icon-remove-fake-account.9653c9dd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};